import { useLocalStorage } from "nsitools-react";
import * as React from "react";

type CriteriaRouteType = {
  [route: string]: any;
};

interface ISearchCriteriaContext {
  setCriterias: (route: string, criteria: object) => void;
  criterias: CriteriaRouteType;
  clearCriterias: () => void;
}
const SearchCriteriaContext = React.createContext<ISearchCriteriaContext>(null);

const LOCAL_STORAGE_KEY = "SearchCriterias";

export const SearchCriteriaProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const [routeCriteria, setRouteCriteria] = useLocalStorage<CriteriaRouteType>(LOCAL_STORAGE_KEY, {});
  const clearCriterias = React.useCallback(() => {
    setRouteCriteria({});
  }, [setRouteCriteria]);
  const setCriterias = React.useCallback(
    (route: string, sObj: any) => {
      const origString = JSON.stringify(routeCriteria[route]);
      const objString = JSON.stringify(sObj);
      if (origString !== objString) {
        setRouteCriteria((c) => {
          return {
            ...c,
            [route]: sObj,
          };
        });
      }
    },
    [routeCriteria, setRouteCriteria],
  );

  return (
    <SearchCriteriaContext.Provider value={{ criterias: routeCriteria, setCriterias, clearCriterias }}>
      {children}
    </SearchCriteriaContext.Provider>
  );
};

export const useSearchCriteriaContext = () => React.useContext(SearchCriteriaContext);
